  import React, { useEffect, useState } from "react";
  import { useParams, useNavigate } from "react-router-dom";
  import {
    Typography,
    Button,
    Card,
    Image,
    Descriptions,
    Divider,
    Row,
    Col,
    Tag,
    InputNumber,
    Switch,
  } from "antd";
  import { RollbackOutlined } from "@ant-design/icons";
  import Pageloader from "../../../components/loader";
  import * as workActions from "../../../redux/actions/work.actions";
  import { connect } from "react-redux";
  import { bindActionCreators } from "redux";
  import { EyeOutlined, EyeInvisibleOutlined } from "@ant-design/icons";
  import { userhasPermissionHelper } from "../../../utils/Helpers";
  import { PERMISSION_CONSTANT } from "../../../utils/constants/app";


  const { Title } = Typography;

  const WorkDetail = (props) => {
    const { workId } = useParams();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [workItems, setWorkItems] = useState([]);
    const [expanded, setExpanded] = useState({}); // track expand/collapse per card
    const [isApproved, setIsApproved] = useState("pending"); // new toggle state
    const [disableApprove, setDisableApprove] = useState(false);
    const [selectedShortPick, setSelectedShortPick] = useState({});
    const [bulkLoading, setBulkLoading] = useState(false);
    const [picturePackedTimeLoading, setPicturePackedTimeLoading] = useState(false);
    const [disablePicturePackedTime, setDisablePicturePackedTime] = useState(false);
    const [hasPackerTime, setHasPackerTime] = useState(false);


    useEffect(() => {
      fetchWorkDetail();
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fetchTaskPackerInfo = async (orderId) => {
      if (!orderId) return;

      const res = await props.workActions.getTaskByOrderIdAction(orderId);
      if (res?.status && Array.isArray(res.data) && res.data.length > 0) {
        const pickerPacker = res.data[0]?.order_details?.picker_packer;
        setHasPackerTime(!!pickerPacker?.packer_time);
      }
    };

    const fetchWorkDetail = async () => {
      try {
        await props.workActions.getWorkDetailAction(workId).then(async (res) => {
          if (res && res.status) {
            const data = res.data || [];
            setWorkItems(data);
            const allExpanded = {};
            const expandedMap = {};
            const selectedMap = {};
            const selectionMap = {};

            data.forEach((item) => {
              expandedMap[item._id] = true;
              if (item.itemApprovalStatus === "approved") {
                selectionMap[item._id] = "approved";
              } else if (item.itemApprovalStatus === "pending") {
                selectionMap[item._id] = "pending";
              }
            });
            setExpanded(expandedMap);
            setSelectedShortPick(selectionMap);
            setExpanded(allExpanded);
            data.forEach((item) => {
              allExpanded[item._id] = true;
            });
            setExpanded(allExpanded);
            if (data[0]?.partialAprovalStatus) {
              setIsApproved(data[0].partialAprovalStatus);
            }

            if (data[0]?.orderId) {
              await fetchTaskPackerInfo(data[0].orderId);
            }
          }
        });
      } finally {
        setLoading(false);
      }
    };

    const handleReleaseWork = async (roleType) => {
      if (workItems[0]) {
        await props.workActions.releaseWorkAction(workItems[0].workId, roleType, navigate);
      }
    };

  const handleToggleApprove = async (checked) => {
    if (disableApprove) return; // prevent multiple clicks

    const newStatus = checked ? "approved" : "pending";
    setIsApproved(newStatus);
    setDisableApprove(true); // disable switch for 10 seconds

    console.log(
      `Toggled Approval: workId=${workItems[0]?.orderId}, status=${newStatus}`
    );

    try {
      await props.workActions.approveWorkAction(workItems[0]?.orderId, newStatus);
    } catch (err) {
      console.error("Error approving work:", err);
    } finally {
      setTimeout(() => {
        setDisableApprove(false);
        console.log("Approve switch re-enabled");
      }, 10000);
    }
  };

  const handleSelectShortPick = (checked, item) => {
    setSelectedShortPick((prev) => ({
      ...prev,
      [item._id]: checked ? "approved" : "pending",
    }));
  };

  const hasSelectedShortPick = Object.values(selectedShortPick).some(Boolean);

  const handleAllowAllShortPick = async () => {
    const user = props.user || {};
    const actionPerformedBy = {
      userId: user.id != null ? String(user.id) : "",
      userName: user.name || "",
      userEmail: user.email || "",
    };
    const payload = workItems
      .filter((item) => selectedShortPick[item._id]) // has intent
      .map((item) => ({
        workId: item.workId,
        sku: item.sku,
        bundle_id: item.bundle_id ?? null,
        status: selectedShortPick[item._id], // ✅ approved OR pending
        actionPerformedBy,
      }));

    if (payload.length === 0) return;

    try {
      setBulkLoading(true);
      await props.workActions.approveBulkPartialWorkAction(payload);
      await fetchWorkDetail(); // refresh truth
    } catch (err) {
      console.error(err);
    } finally {
      setBulkLoading(false);
    }
  };

  const buildPicturePackedTimePayload = () => {
    const first = workItems[0] || {};
    return {
      orderId: String(first.orderId ?? ""),
      storeId: String(first.storeId ?? ""),
      orderStatus: first.status ?? "pending",
      orderItems: workItems.map((item) => ({
        name: item.productName ?? "",
        sku: item.sku ?? "",
        quantity: item.orderedQty ?? 0,
        price: String(item.unit_price ?? item.total_price ?? "0"),
        image: item.image ?? "",
      })),
      subTotal: String(first.subTotal ?? ""),
      paymentType: first.paymentType ?? "",
      totalAmount: String(first.totalAmount ?? ""),
    };
  };

  const handleGetPicturePackedTime = async () => {
    if (!workItems.length || disablePicturePackedTime) return;

    setDisablePicturePackedTime(true);
    setTimeout(() => setDisablePicturePackedTime(false), 5000);

    try {
      setPicturePackedTimeLoading(true);
      const result = await props.workActions.getPicturePackedTimeAction(
        workId,
        buildPicturePackedTimePayload()
      );
      if (result?.status) {
        setHasPackerTime(true);
      }
    } catch (err) {
      console.error("Error fetching picture packed time:", err);
    } finally {
      setPicturePackedTimeLoading(false);
    }
  };

    const [changedQty, setChangedQty] = useState({});
    const [saving, setSaving] = useState(false);

    const handleSaveQty = async () => {
    // Build data only for changed items
    const updated = workItems
      .filter((item) => changedQty[item._id]) // use _id to track per item
      .map((item) => ({
        orderId: item.orderId,
        sku: item.sku,
        bundle_id: item.bundle_id ?? null,
        actual_invoiced_qty: item.inputQty || 0,
      }));

    if (updated.length === 0) return;

    try {
      setSaving(true);
      await props.workActions.updateWorkQtyAction(updated);
      await fetchWorkDetail();
      setChangedQty({});
    } catch (err) {
      console.error("Error saving qty:", err);
    } finally {
      setSaving(false); // ✅ stop loading
    }
  };

    // Utility: Capitalize
    const formatStatus = (status) => {
      if (!status) return "-";
      return status.charAt(0).toUpperCase() + status.slice(1);
    };

    // Utility: Status colors
    const getStatusColor = (status) => {
      switch (status) {
        case "open":
          return "blue";
        case "cancel":
          return "red";
        case "canceled":
          return "red";
        case "completed":
          return "green";
        case "in-process":
          return "orange";
        default:
          return "default";
      }
    };

    const formatPKR = (value) => {
      if (value === null || value === undefined || value === "-") return "-";
      return new Intl.NumberFormat("en-PK", {
        style: "currency",
        currency: "PKR",
        minimumFractionDigits: 0,
      }).format(value);
    };

    const canViewShortPick =
      userhasPermissionHelper(
        props.permissions,
        PERMISSION_CONSTANT.VIEW_ALLOW_SHORT_PICK
      );

    const hasShortPickItems = workItems.some(
      (item) => item?.itemApprovalStatus != null
    );

    const hasShortPickItemsStatus = workItems.some(
      (item) => item?.status !== "completed" && item?.status !== "canceled"
    );

    const canGetPicturePackedTime =
      !workItems.some((item) => item?.status === "canceled" || item?.status === "cancel") &&
      !hasPackerTime;

    if (loading) return <Pageloader />;

    if (!workItems || workItems.length === 0) {
      return (
        <div className="page-content">
          <div
            className="page-content-header"
            style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
          >
            <Title level={4}>Work items not found.</Title>
            <Button onClick={() => navigate("/works")} type="primary" icon={<RollbackOutlined />}>
              Back
            </Button>
          </div>
        </div>
      );
    }

    return (
      <div className="page-content">
        <div
          className="page-content-header"
          style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
        >
          <Title level={2}>Work Detail - {workId}</Title>
          <div>
            {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_RELEASE_WORK) && (
              <>
                {workItems[0]?.status === "in-process" && (
                  <Button
                    type="primary"
                    onClick={() => handleReleaseWork("picker")}
                    style={{ marginRight: 10 }}
                  >
                    Un-assign Work
                  </Button>
                )}
                {workItems[0]?.packerStatus === "in-process" && (
                  <Button
                    type="primary"
                    onClick={() => handleReleaseWork("packer")}
                    style={{ marginRight: 10 }}
                  >
                    Un-assign Picture
                  </Button>
                )}
              </>
            )}

            {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_WORK_APPROVAL_BUTTON) && (
              <>
              <div style={{ display: "inline-flex", alignItems: "center", marginRight: 10 }}>
                <span style={{ marginRight: 8 }}>Allow 0 qty order to be cancelled:</span>
                <Switch
                  checked={isApproved === "approved"} // maps approved/pending to boolean
                  onChange={(checked) => handleToggleApprove(checked)}
                  disabled={disableApprove} // proper boolean disable
                  checkedChildren="Approved"
                  unCheckedChildren="Pending"
                />
              </div>
              </>
            )}
          {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_PICTURE_PACKED_TIME) && canGetPicturePackedTime && (
              <>
            <Button
              type="primary"
              loading={picturePackedTimeLoading}
              disabled={disablePicturePackedTime}
              onClick={() => handleGetPicturePackedTime()}
              style={{ marginRight: 10 }}
            >
              Get Picture Packed Time
            </Button>
            </>
            )}

            {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ACTUAL_INVOICE_QTY) && (
              <>
                {workItems.some((item) => item.status === "completed" || item.status === "canceled") && (
                  <Button
                    type="primary"
                    disabled={!Object.values(changedQty).some((v) => v === true)}
                    loading={saving}
                    onClick={handleSaveQty}
                  >
                    Save Qty
                  </Button>
                )}
              </>
            )}
          </div>
        </div>

        <Divider />

        <Row gutter={[16, 16]}>
          {workItems.map((item) => (
            <Col xs={24} key={item._id}>
              <Card
                title={
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span>
                      SKU: <b>{item?.sku || "-"}</b>
                    </span>
                    <div>
                      {item?.itemApprovalStatus != null &&
                        canViewShortPick &&
                        item?.status !== "completed" &&
                        item?.status !== "canceled" && (
                          <div style={{ display: "inline-flex", alignItems: "center", marginRight: 10 }}>
                            <span style={{ marginRight: 8 }}>Allow Short Pick:</span>
                            <Switch
                              checked={selectedShortPick[item?._id] === "approved"}
                              onChange={(checked) => handleSelectShortPick(checked, item)}
                              checkedChildren="Selected"
                              unCheckedChildren="Select"
                            />
                          </div>
                        )}
                    {userhasPermissionHelper(props.permissions, PERMISSION_CONSTANT.VIEW_ACTUAL_INVOICE_QTY) && (
                      <>
                        {(item?.status === "completed" || item?.status === "canceled") && (
                          <InputNumber
                            min={0}
                            placeholder="Enter Qty"
                            style={{ width: 100, marginRight: "15px" }}
                            value={item.inputQty || 0}
                            onChange={(value) => {
                              setWorkItems((prev) =>
                                prev.map((w) =>
                                  w._id === item._id ? { ...w, inputQty: value } : w
                                )
                              );

                              setChangedQty((prev) => ({
                                ...prev,
                                [item._id]: true,
                              }));
                            }}
                          />
                        )}
                      </>
                    )}
                    <Tag color={getStatusColor(item?.status)}>
                      {formatStatus(item?.status)}
                    </Tag>
                    </div>
                  </div>
                }
                bordered
                hoverable
                style={{
                  width: "100%",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  borderRadius: 12,
                }}
                extra={
                    <Button
                      type="link"
                      onClick={() =>
                        setExpanded((prev) => ({
                          ...prev,
                          [item._id]: !prev[item._id],
                        }))
                      }
                    >
                      {expanded[item._id] ? (
                        <EyeInvisibleOutlined />   // Hide Details
                      ) : (
                        <EyeOutlined />            // View Details
                      )}
                    </Button>
                  }
              >
                {expanded[item._id] && (
                  <Descriptions bordered size="small" column={2}>
                    <Descriptions.Item label="Work ID">{item?.workId || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Order ID">{item?.orderId || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Parent SKU">{item?.parent_sku || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Product">{item?.productName || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Unit Price">
                      {formatPKR(item?.unit_price)}
                    </Descriptions.Item>

                    <Descriptions.Item label="Total Price">
                      {formatPKR(item?.total_price)}
                    </Descriptions.Item>
                    <Descriptions.Item label="Ordered Qty">{item?.orderedQty ?? "-"}</Descriptions.Item>
                    <Descriptions.Item label="Picked Qty">{item?.pickedQty ?? "-"}</Descriptions.Item>
                    <Descriptions.Item label="Actual Invoiced Qty">{item?.actualInvoicedQty ?? "-"}</Descriptions.Item>
                    <Descriptions.Item label="Location">{item?.location || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Other Locations">
                      {item?.otherLocations?.length > 0
                        ? item.otherLocations
                            .map(loc => `${loc.location} (${loc.quantity})`)
                            .join(", ")
                        : "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Assigned User">{item?.assignedUser || "-"}</Descriptions.Item>
                    <Descriptions.Item label="User">{item?.user || "-"}</Descriptions.Item>
                    <Descriptions.Item label="Created At">
                      {item?.createdAt ? new Date(item.createdAt).toLocaleString() : "-"}
                    </Descriptions.Item>
                    <Descriptions.Item label="Number Of Times Short Picked">{item?.numberOfTimesShortPicked ?? "-"}</Descriptions.Item>
                    <Descriptions.Item label="Image">
                      {item?.image ? <Image width={120} src={item.image} /> : "-"}
                    </Descriptions.Item>
                  </Descriptions>
                )}
              </Card>
            </Col>
          ))}
        </Row>
        {canViewShortPick &&
          hasShortPickItems &&
          hasShortPickItemsStatus && (
            <div style={{ marginTop: 20, textAlign: "right" }}>
              <Button
                type="primary"
                loading={bulkLoading}
                disabled={bulkLoading}
                onClick={handleAllowAllShortPick}
              >
                Allow All Short Pick
              </Button>
            </div>
          )}
      </div>
    );
  };

  const mapStateToProps = (state) => ({
    workDetail: state.WorkReducer.workDetail,
    permissions: state.PermissionReducer.permissions,
    user: state.authReducer.user,
  });

  const mapDispatchToProps = (dispatch) => ({
    workActions: bindActionCreators(workActions, dispatch),
  });

  export default connect(mapStateToProps, mapDispatchToProps)(WorkDetail);
